import LazyLoadImg from "components/LazyLoadImg";
import { decodeHtmlEntities } from "constant/htmlEntities";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Modal } from "antd";
import { useState } from "react";
import { FaCrown } from "react-icons/fa";
import { RouteName } from "constant/routeNames";
import SubscriptionService from "services/subscription/subscriptionService";
import { ContentType } from "services/subscription/types";
function AlbumCard({
  artwork_url,
  title,
  song_count,
  id,
  artists,
  isLoading,
  path,
  album,
}: any) {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const isPremiumContent = album?.plan_id === 2;
  const isPlusUser = loggedInUser?.is_subscribed;

  //check content access
  const checkContentAccess = async () => {
    try {
      const resp = await SubscriptionService.checkContentAccess(
        ContentType.ALBUMS,
        album?.id,
      );
      return resp.data.has_access;
    } catch (err) {
      console.log("err :::", err);
    }
  };

  const handleAlbumClick = async () => {
    const access = await checkContentAccess();
    if (isPremiumContent && !access) {
      setIsModalOpen(true);
      return;
    }
    navigate(`/music/album/${id}`, { state: { prevPage: path } });
  };

  return (
    <>
      <Modal
        title={null}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
        className="premium-modal"
        styles={{
          content: { backgroundColor: "#111", border: "1px solid #333" },
        }}
      >
        <div className="flex flex-col items-center justify-center p-6 text-center">
          <div className="mb-4 rounded-full bg-[var(--red)]/10 p-4">
            <FaCrown className="text-4xl text-[var(--red)]" />
          </div>
          <h3 className="mb-2 text-2xl font-bold text-white">
            Premium Content
          </h3>
          <p className="mb-6 text-gray-400">
            This is exclusively available for premium subscribers. Upgrade your
            plan to gain full access.
          </p>
          <div className="flex w-full gap-4">
            <button
              onClick={() => setIsModalOpen(false)}
              className="flex-1 rounded-lg border border-gray-600 px-4 py-2 font-semibold text-gray-300 transition hover:bg-[#222]"
            >
              Maybe Later
            </button>
            <Link
              to={RouteName.SubscriptionPlanRoute}
              className="flex flex-1 items-center justify-center rounded-lg bg-[var(--red)] px-4 py-2 font-semibold text-white shadow-md transition hover:opacity-90"
            >
              View Plans
            </Link>
          </div>
        </div>
      </Modal>
      <div
        className="group block w-full cursor-pointer rounded-xl px-2 py-2 text-white shadow-lg transition-all duration-300 ease-out hover:-translate-y-1 hover:bg-slate-800 hover:text-slate-300 hover:shadow-xl"
        onClick={handleAlbumClick}
      >
        {/* image */}
        <div className="relative aspect-square w-full overflow-hidden rounded-lg ring-1 ring-white/5 transition-all duration-300 group-hover:ring-2 group-hover:ring-[var(--red)]/40">
          {/* Premium pill */}
          {isPremiumContent && (
            <div className="absolute left-2 top-2 z-10 flex items-center gap-1 rounded-full border border-white/15 bg-black/40 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white shadow-lg backdrop-blur-md">
              <FaCrown className="text-[10px] text-[var(--red)]" />
              <span>Premium</span>
            </div>
          )}

          <LazyLoadImg
            imgSrc={artwork_url}
            imgAlt={"Artist Album"}
            imgHeight={"100%"}
            imgWidth={"100%"}
            wrapperProps={{
              style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                display: "block",
              },
            }}
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
        </div>
        <div className="relative top-1">
          <div className="my-[4px]">
            <p
              className="line-clamp-2 text-[15px] font-[600] leading-tight transition-colors group-hover:text-white"
            >
              {decodeHtmlEntities(title)}
            </p>
            <div className="z-50 text-sm ">
              <ReactTooltip
                id={`music-album-card-title-${title}`}
                place="top"
                content={title}
                style={{ width: "180px" }}
              />
            </div>

            <p className="mt-[5px] text-[12px] font-[400] text-white/60">
              {decodeHtmlEntities(artists?.[0]?.name)}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AlbumCard;